import * as tslib_1 from "tslib";
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { action } from 'satcheljs/lib/legacy';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { lazyUnsubscribeWebPushNotifications } from 'owa-webpush-notifications';
import { getOptionsForFeature, OwsOptionsFeatureType, } from 'owa-outlook-service-options';
import { trace } from 'owa-trace';
var signoutUrl = '/owa/logoff.owa';
export var signout = action('signout')(function signout(locationObj) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var webPushNotificationsOptions, unsubscribe, error_1, userConfiguration;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(isControlFeatureEnabled('fwk-webPushNotification') &&
                        isControlFeatureEnabled('fwk-webPushNotificationSignout'))) return [3 /*break*/, 6];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    webPushNotificationsOptions = getOptionsForFeature(OwsOptionsFeatureType.WebPushNotifications);
                    if (!(webPushNotificationsOptions == null || webPushNotificationsOptions.enabled)) return [3 /*break*/, 4];
                    return [4 /*yield*/, lazyUnsubscribeWebPushNotifications.import()];
                case 2:
                    unsubscribe = _a.sent();
                    return [4 /*yield*/, unsubscribe(window)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    error_1 = _a.sent();
                    trace.error('[WebPush] Failed to unsubscribe on signout, error: ' + error_1);
                    return [3 /*break*/, 6];
                case 6:
                    userConfiguration = getUserConfiguration();
                    if (userConfiguration.ApplicationSettings.CloseWindowOnLogout) {
                        // TODO: Task 644 - Put up message box saying to sign out by closing all windows.
                        // Only needed for on-prem
                    }
                    if ('sessionStorage' in window && window.sessionStorage) {
                        window.sessionStorage.clear();
                    }
                    locationObj.assign(signoutUrl);
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=signout.js.map